import React from "react";
import PdfViewer from "../../PdfViewer";

const GeneracionDemandaOmnicanal = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/01-Generación-de-Demanda-Omnicanal.pdf`;
  /*const pdfUrl = "/pdf/01-Generación-de-Demanda-Omnicanal.pdf";*/

  return (
    <>
      <main>
        <div class="titulo">
          <h1>Generación Demanda Omnicanal</h1>
        </div>
        <div className="pdf-container">
          <PdfViewer pdfUrl={pdfUrl} />
        </div>
      </main>
    </>
  );
};

 export default GeneracionDemandaOmnicanal;
